import React, { useEffect, useState } from 'react';
import { Country } from '../../../global';
import axiosHelper from '../../../helpers/axiosHelper';
import { GenericSelect } from './GenericSelect';
interface Props {
  value?: Country;
  onChange: (country: Country | null) => void;
}

const CountrySelect: React.FC<Props> = ({ value, onChange }) => {
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    axiosHelper.getCountries().then(setCountries);
  }, []);

  return <GenericSelect items={countries} value={value} onChange={onChange} placeholder="Select country..." renderItem={(c) => c.name} />;
};
export default CountrySelect;
